'use strict'

const TextExpand = {
  ctxClass: 'text-expand',
  contentClass: 'text-expand__content',
  moreClass: 'text-expand__more',
  ctaClass: 'text-expand__cta',
}

TextExpand.init = function () {
  $(document).ready(function() {
    var ctx = $('.' + TextExpand.ctxClass)
    var ctas = $('.' + TextExpand.ctaClass)

    ctx.each(function (i, el) {
      var $el = $(el)
      var hr = $el.find('hr')
      var cta = $el.find('.' + TextExpand.ctaClass)
      var content = $el.find('.' + TextExpand.contentClass)
      var moreEl = null
      var moreBlock = null

      if (hr.length <= 0) {
        cta.remove()
      } else {
        // Clone elements
        moreEl = hr.nextAll().clone()

        // Remove everything not neccessary
        hr.nextAll().remove()
        hr.remove()

        // Generate 'more'-block and attach to content
        moreBlock = $('<div/>')
        moreBlock.addClass(TextExpand.moreClass).append(moreEl)
        moreBlock.appendTo(content)
      }
    })

    ctas.bind('click', function (e) {
      e.preventDefault()
      $(this).closest('.' + TextExpand.ctxClass).toggleClass(TextExpand.ctxClass + '--open')
    });
  });
}

export { TextExpand }
